import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIClient } from '../../helpers/api_helper';
import * as ToastHelper from '../../helpers/toast_helper';

const prefix = 'user';
const tname = '用户';

export const getAll = createAsyncThunk(`${prefix}/get-all`, async function () {
    const { data } = await APIClient.get('/users');
    return data;
});

export const create = createAsyncThunk(`${prefix}/create`, async function (payload) {
    try {
        const response = await APIClient.post('/users', payload);
        ToastHelper.createSucceeded(tname);
        return response.data;
    } catch (error) {
        ToastHelper.createFailed(tname);
        throw error;
    }
});

export const update = createAsyncThunk(`${prefix}/update`, async function (payload) {
    try {
        const response = await APIClient.patch(`/users/${payload.id}`, payload);
        ToastHelper.updateSucceeded(tname);
        return response.data;
    } catch (error) {
        ToastHelper.updateFailed(tname);
        throw error;
    }
});

export const remove = createAsyncThunk(`${prefix}/remove`, async function (id) {
    try {
        await APIClient.delete(`/users/${id}`);
        ToastHelper.removeSucceeded(tname);
        return id;
    } catch (error) {
        ToastHelper.removeFailed(tname);
        throw error;
    }
});

// export const verifyToken = createAsyncThunk(`/verifyToken`, async function (token) {
//     const { data } = await APIClient.get(`/verifyToken?token=${token}`);
//     return data;
// });